module.exports = __webpack_public_path__ + "static/media/5.4fe4816e.jpg";